import { useState, useEffect } from 'react'
import { getSessionId } from '../lib/session.js'
import { checkConsent, recordConsent } from '../lib/api.js'

const CONSENT_KEY = 'aboutmecosmic_consent'

export function useConsent() {
  const [consentGiven, setConsentGiven] = useState(false)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    async function verify() {
      const localFlag = localStorage.getItem(CONSENT_KEY)
      if (localFlag !== 'true') {
        setConsentGiven(false)
        setLoading(false)
        return
      }

      try {
        const sessionId = getSessionId()
        const result = await checkConsent(sessionId)
        setConsentGiven(result.consented)
      } catch {
        setConsentGiven(true)
      } finally {
        setLoading(false)
      }
    }
    verify()
  }, [])

  async function giveConsent(ipHash = '', userAgent = '') {
    // Guard against non-string args (e.g. React event objects)
    if (typeof ipHash !== 'string') ipHash = ''
    if (typeof userAgent !== 'string') userAgent = ''

    const sessionId = getSessionId()
    try {
      await recordConsent({ session_id: sessionId, ip_hash: ipHash, user_agent: userAgent })
      // Strict: only mark as given if backend confirmed
      localStorage.setItem(CONSENT_KEY, 'true')
      setConsentGiven(true)
      return true
    } catch (err) {
      console.error('Consent sync failed:', err)
      // Do NOT set localStorage — user must retry
      return false
    }
  }

  return { consentGiven, loading, giveConsent }
}
